import * as yup from "yup";
import { Genders, Pronouns, Races, Ethnicities, Citizenships } from "types/gql-types";

const propertyManagerProfile = yup.object({
  title: yup.string().trim(),
});

const clientProfile = yup.object({
  dateOfBirth: yup.date().nullable(),
  gender: yup.string().trim().nullable().oneOf([null, ...Object.values(Genders)]),
  pronouns: yup.string().when("gender", {
    is: Genders.OTHER,
    then: () => yup.string().trim().nullable().oneOf([null, ...Object.values(Pronouns)]),
    otherwise: (schema) => schema.nullable(),
  }),
  customPronouns: yup.string().when("pronouns", {
    is: Pronouns.OTHER,
    then: () => yup.string().trim().nullable().required(),
    otherwise: (schema) => schema.nullable(),
  }),
  race: yup.string().trim().nullable().oneOf([null, ...Object.values(Races)]),
  ethnicity: yup.string().trim().nullable().oneOf([null, ...Object.values(Ethnicities)]),
  citizenship: yup.string().trim().nullable().oneOf([null, ...Object.values(Citizenships)]),
});

export {
  propertyManagerProfile,
  clientProfile,
};
